/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, TextField } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";

type CustomerPersonalDataProps = {
  children:any;
  title: string;
  gridSize: number;
  customer: any;
  handleChangeCustomerDetails: (customerDetails: any) => void;
};

export default function CustomerPersonalData(props: CustomerPersonalDataProps) {
  const { title, gridSize, customer, handleChangeCustomerDetails } = props;
  return (
    <Grid item xs={12} md={gridSize} lg={gridSize}>
      <div
        style={{
          padding: 15,
        }}
      >
        <h3 style={{ margin: 10 }}>{title}</h3>

        <p>
          {Vocabulary.name}: &nbsp;{customer.name}
        </p>
        <p>
          {Vocabulary.email}: &nbsp;{customer.email}
        </p>
        <TextField
          type="text"
          label={Vocabulary.phone}
          variant="standard"
          fullWidth
          value={customer.personalData.phoneNumber}
          onChange={(e) => {
            const newCustomer = structuredClone(customer);
            newCustomer.personalData.phoneNumber = e.target.value;
            handleChangeCustomerDetails(newCustomer);
          }}
          style={{ margin: "10px 0px" }}
        />
      </div>
      <div>{props.children}</div>
    </Grid>
  );
}
